<template>
    <fieldset class="w-full">
        <legend class="font-bold">
            {{ field.display }} <span v-if="field.isRequired" class="font-normal text-base text-gray-800">*</span>
        </legend>
        <template v-for="(optionLabel, optionValue) in fieldOptions">
            <label :class="{'block w-full mb-1': !field.inline}">
                <input :title="optionLabel || field.placeholder" type="radio" :name="field.handle" :value="optionValue" :required="field.isRequired" :checked="isChecked(optionValue)" @change="$emit('change', optionValue)">
                {{ optionLabel || optionValue }}
            </label>
        </template>
    </fieldset>
</template>

<script setup>
import {defineField} from "./BaseField.js";
import {reactive} from "vue";

defineEmits(['change']);

const field = defineField();

const { options, old = null } = field

let fieldOptions = options

if(Array.isArray(options)){
    fieldOptions = reactive(options.reduce((acc, cur) => {
        if(cur.key !== undefined && cur.value !== undefined){
            acc[cur.key] = cur.value
        }

        return acc
    }, {}))
}

const isChecked = (value) => {
    if (!old) {
        return false;
    }

    return old === value;
}
</script>
